import { render, staticRenderFns } from "./match-detail.vue?vue&type=template&id=3b34a958&scoped=true&"
import script from "./match-detail.vue?vue&type=script&lang=js&"
export * from "./match-detail.vue?vue&type=script&lang=js&"
import style0 from "./match-detail.vue?vue&type=style&index=0&id=3b34a958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34a958",
  null
  
)

export default component.exports